module.exports = "../dist/img/upper-banner-17.5440.jpg";